"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldEditorSelectList = exports.CSS = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var image_button_1 = require("../../../components/button/image.button");
var icons_1 = require("../../../components/icon/icons");
var input_1 = require("../../../components/input/input");
var input_state_1 = require("../../../components/input/input.state");
var theme_1 = require("../../../components/theme");
var i18n_1 = require("../../../i18n");
var mithril_1 = require("../../../mithril");
var services_1 = require("../../../services");
var classnames_1 = require("../../../util/classnames");
var form_field_editor_1 = require("./form.field.editor");
exports.CSS = {
    container: 'c-FdcSelectList',
    title: 'c-FdcSelectList__title',
    list: 'c-FdcSelectList__list',
    option: 'c-FdcSelectList__option',
    value: 'c-FdcSelectList__value',
    ghost: 'c-FdcSelectList__ghost',
    color: 'c-FdcSelectList__color',
    colorTitle: 'c-FdcSelectList__colorTitle'
};
var inputHeight = 32;
var colorPickerHeight = 24;
var colorPickerWidth = 32;
var colorPickerMargin = 20;
var keyInputWidth = 320;
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.container] = {
        width: '100%',
        display: 'flex',
        'flex-direction': 'column'
    },
    _a[exports.CSS.list] = {
        display: 'flex',
        width: '100%',
        'align-items': 'center',
        padding: theme_1.DefaultTheme.space(2)
    },
    _a[exports.CSS.option] = {
        width: "".concat(keyInputWidth, "px"),
        height: "".concat(inputHeight, "px"),
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        paddingRight: '12px'
    },
    _a[exports.CSS.ghost] = {
        color: theme_1.DefaultTheme.font.color.supporting
    },
    _a[exports.CSS.value] = {
        width: "".concat(keyInputWidth, "px"), // TODO this is from the input width
        height: "".concat(inputHeight, "px"),
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        paddingRight: '12px'
    },
    _a[exports.CSS.colorTitle] = (_b = {
            width: "".concat(colorPickerWidth, "px"),
            marginRight: "".concat(colorPickerMargin, "px")
        },
        _b["& + .".concat(exports.CSS.option)] = {
            width: "".concat(keyInputWidth - colorPickerWidth - colorPickerMargin, "px")
        },
        _b),
    _a[exports.CSS.title] = {
        'font-weight': 'bold',
        'margin-bottom': theme_1.DefaultTheme.space(1),
        color: theme_1.DefaultTheme.font.color.supporting,
        height: '20px'
    },
    _a[exports.CSS.color] = (_c = {
            width: "".concat(colorPickerWidth, "px"),
            height: "".concat(colorPickerHeight, "px"),
            overflow: 'hidden',
            boxSizing: 'border-box',
            borderRadius: '4px',
            border: '2px solid #c9c9c9',
            marginRight: "".concat(colorPickerMargin, "px")
        },
        _c['& input[type=color]'] = {
            width: 'calc(100% + 12px)',
            height: 'calc(100% + 12px)',
            padding: 0,
            margin: '-6px',
            cursor: 'pointer'
        },
        _c["& + .".concat(exports.CSS.option)] = (_d = {
                width: "".concat(keyInputWidth - colorPickerWidth - colorPickerMargin, "px")
            },
            _d["& .mdl-textfield"] = {
                width: "calc(300px - ".concat(colorPickerWidth + colorPickerMargin, "px)")
            },
            _d),
        _c),
    _a));
function setterListValue(field, type, index) {
    return function (val) {
        var _a = index < field.options.length ? field.options[index] : { text: '', value: String(index), color: '#a0aec0' }, text = _a.text, value = _a.value, color = _a.color;
        if (type === 'text') {
            field.Mutator.option({ text: val, value: value, color: color }, index);
        }
        else if (type === 'value') {
            field.Mutator.option({ text: text, value: val, color: color }, index);
        }
        else if (type === 'color') {
            field.Mutator.option({ text: text, value: value, color: val }, index);
        }
    };
}
var FormFieldEditorSelectList = /** @class */ (function (_super) {
    tslib_1.__extends(FormFieldEditorSelectList, _super);
    function FormFieldEditorSelectList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isAnalyst = services_1.Services.User.isIkeAnalyst(services_1.Services.User.current);
        return _this;
    }
    FormFieldEditorSelectList.prototype.viewInfoRW = function () {
        var children = [
            this.viewOptionTitle()
        ];
        for (var index = 0; index < this.field.options.length; index++) {
            var textState = this.getInputState('text', index);
            var valueState = this.getInputState('value', index);
            var colorState = this.getInputState('color', index);
            var node = (0, mithril_1.m)('div', { className: exports.CSS.list }, tslib_1.__spreadArray(tslib_1.__spreadArray([], this.viewSelectListOption(input_1.Input.view(textState), input_1.Input.view(valueState), services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) && this.field.isMapColorField ? input_1.Input.view(colorState, { rawInputOnly: true }) : null), true), [
                index > 0 ? this.viewOptionDeleteButton(index) : null
            ], false));
            children.push(node);
        }
        if (!this.isLocked || this.isAnalyst) {
            children.push(this.viewNewSelectListOption());
        }
        return (0, mithril_1.m)('div', { className: exports.CSS.container }, children);
    };
    FormFieldEditorSelectList.prototype.viewOptionTitle = function () {
        var titleArr = [];
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) && this.field.isMapColorField) {
            titleArr.push((0, mithril_1.m)('div', { className: (0, classnames_1.classNames)(exports.CSS.title, exports.CSS.colorTitle) }, (0, i18n_1.Translate)(i18n_1.T.COLOR)));
        }
        titleArr.push((0, mithril_1.m)('div', { className: (0, classnames_1.classNames)(exports.CSS.title, exports.CSS.option) }, (0, i18n_1.Translate)(i18n_1.T.SELECT_LIST_TITLE)), (0, mithril_1.m)('div', { className: (0, classnames_1.classNames)(exports.CSS.title, exports.CSS.value) }, (0, i18n_1.Translate)(i18n_1.T.SELECT_LIST_VALUE)));
        return (0, mithril_1.m)('div', { className: exports.CSS.list }, titleArr);
    };
    FormFieldEditorSelectList.prototype.viewSelectListOption = function (key, value, color) {
        return [
            services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) && this.field.isMapColorField ? (0, mithril_1.m)('div', { className: exports.CSS.color }, color) : null,
            (0, mithril_1.m)('div', { className: exports.CSS.option }, key),
            (0, mithril_1.m)('div', { className: exports.CSS.value }, value)
        ];
    };
    FormFieldEditorSelectList.prototype.viewNewSelectListOption = function () {
        var index = this.field.options.length;
        var textState = this.getInputState('text', index, "".concat((0, i18n_1.Translate)(i18n_1.T.SELECT_LIST_TITLE), " ").concat(index));
        var defaultValue = "".concat((0, i18n_1.Translate)(i18n_1.T.SELECT_LIST_VALUE), " ").concat(index);
        var valueState = this.getInputState('value', index, defaultValue, defaultValue);
        var colorState = this.getInputState('color', index, '', '#a0aec0');
        return (0, mithril_1.m)('div', { className: exports.CSS.list }, [
            services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) && this.field.isMapColorField ? (0, mithril_1.m)('div', { className: "".concat(exports.CSS.color, " ").concat(exports.CSS.ghost) }, input_1.Input.view(colorState, { rawInputOnly: true })) : null,
            (0, mithril_1.m)('div', { className: "".concat(exports.CSS.option, " ").concat(exports.CSS.ghost) }, input_1.Input.view(textState)),
            (0, mithril_1.m)('div', { className: "".concat(exports.CSS.value, " ").concat(exports.CSS.ghost) }, input_1.Input.view(valueState))
        ]);
    };
    FormFieldEditorSelectList.prototype.viewOptionDeleteButton = function (index) {
        var _this = this;
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.DELETE, {
            onclick: function () {
                _this.field.Mutator.remove(index);
                _this.state.clearStates();
            }
        });
    };
    FormFieldEditorSelectList.prototype.getInputState = function (type, index, placeholder, value) {
        var fieldKey = "".concat(index, ":").concat(type);
        var editState = this.state.get(fieldKey);
        if (editState == null) {
            editState = this.state.child(i18n_1.T.EMPTY, fieldKey, type === 'color' ? input_state_1.InputStateTypes.COLOR : input_state_1.InputStateTypes.TEXT);
            editState.onValue(setterListValue(this.field, type, index));
            if (placeholder != null) {
                editState.setPlaceholder(placeholder);
            }
            if (value != null) {
                editState.setValue(value);
            }
            else if (index < this.field.options.length) {
                editState.setValue(this.field.options[index][type]);
            }
            if (index === 0 && type === 'value') {
                editState.setDisabled(true);
            }
            if (this.isLocked && !this.isAnalyst) {
                editState.setDisabled(true);
            }
        }
        editState.isRequired = type !== 'color' ? placeholder == null : false;
        return editState;
    };
    return FormFieldEditorSelectList;
}(form_field_editor_1.FormFieldEditor));
exports.FormFieldEditorSelectList = FormFieldEditorSelectList;
//# sourceMappingURL=form.field.editor.select.list.js.map